"use client"
import React, { useContext } from "react"
import {Box, Paper, Typography, useMediaQuery, useTheme} from "@mui/material"

import { TranslationContext } from "@/configs/context"
import Grid from "@mui/material/Grid"
import FooterWrapper from "@/ui/layouts/FooterWrapper"


export default function CGUWrapper ({  }) {
  const theme = useTheme()
  // @ts-ignore
  const { t }: object = useContext(TranslationContext)
  const matchMd = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <React.Suspense fallback={<div />}>
      <Box
        sx={{
          p: 2,
          flexGrow: 1,
          pt: { xs: 8, md: 10 },
        }}
      >
        <Grid
          container
          alignItems="flex-start"
          justifyContent="center"
          spacing={{ xs: 1, lg: 3 }}
        >
          <Grid size={{ xs: 12, sm: 12, md: 11, lg: 11, xl: 8 }}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                textAlign: matchMd ? "left" : "center",
              }}
            >
              <Typography variant="h6" gutterBottom align={matchMd ? "justify" : "left"}>
                {t('cgu:title1')}
              </Typography>
              <Typography component="p" variant="body2" align={matchMd ? "justify" : "left"}>
                {t('cgu:content1')}
              </Typography>
              <Typography variant="h6" style={{ marginTop: 25 }} align={matchMd ? "justify" : "left"}>
                {t('cgu:title2')}
              </Typography>
              <Typography component="p" variant="body2" align={matchMd ? "justify" : "left"}>
                {t('cgu:content2')}
              </Typography>
              <Typography variant="h6" style={{ marginTop: 25 }} align={matchMd ? "justify" : "left"}>
                {t('cgu:title3')}
              </Typography>
              <Typography component="p" variant="body2" align={matchMd ? "justify" : "left"}>
                {t('cgu:content3')}
              </Typography>
              <Typography variant="h6" style={{ marginTop: 25 }} align={matchMd ? "justify" : "left"}>
                {t('cgu:title4')}
              </Typography>
              <Typography component="p" variant="body2" align={matchMd ? "justify" : "left"}>
                {t('cgu:content4')}
              </Typography>
              <Typography variant="h6" style={{ marginTop: 25 }} align={matchMd ? "justify" : "left"}>
                {t('cgu:title5')}
              </Typography>
              <Typography component="p" variant="body2" align={matchMd ? "justify" : "left"}>
                {t('cgu:content5')}
              </Typography>
              <Typography variant="h6" style={{ marginTop: 25 }} align={matchMd ? "justify" : "left"}>
                {t('cgu:title6')}
              </Typography>
              <Typography component="p" variant="body2" align={matchMd ? "justify" : "left"}>
                {t('cgu:content6')}
              </Typography>
              <Typography variant="h6" style={{ marginTop: 25 }} align={matchMd ? "justify" : "left"}>
                {t('cgu:title7')}
              </Typography>
              <Typography component="p" variant="body2" align={matchMd ? "justify" : "left"}>
                {t('cgu:content7')}
              </Typography>
              <Typography variant="h6" style={{ marginTop: 25 }} align={matchMd ? "justify" : "left"}>
                {t('cgu:title8')}
              </Typography>
              <Typography component="p" variant="body2" align={matchMd ? "justify" : "left"}>
                {t('cgu:content8')}
              </Typography>
              <Typography variant="h6" style={{ marginTop: 25 }} align={matchMd ? "justify" : "left"}>
                {t('cgu:title9')}
              </Typography>
              <Typography component="p" variant="body2" align={matchMd ? "justify" : "left"}>
                {t('cgu:content9')}
              </Typography>
            </Paper>
            <FooterWrapper />
          </Grid>
        </Grid>
      </Box>
    </React.Suspense>
  )
}